import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <div className='footer-ctn'>
      <footer className='footer'>Created by: Holmes & Watson</footer>
    </div>
  );
}

export default Footer;
